<div class="detail-parent-card gap-3">
  <span class="detail-card-title" i18n>Deposit Instructions</span>
  <div *ngIf="!summary?.paymentBankAccount && !summary?.paymentPaylineAccount" class="inner-card">
    <div i18n class="account-name">Written Cheque</div>
  </div>

  <div *ngIf="summary?.paymentBankAccount as bankAccount" class="inner-card d-flex flex-column gap-3">
    <div class="account-name">{{ bankAccount.nickname }}</div>
    <div class="bank-info-grid">
      <app-review-entry label="Institution Number" i18n-label [value]="bankAccount.institutionNumber" />
      <app-review-entry label="Transit Number" i18n-label [value]="bankAccount.transitNumber" />
      <app-review-entry label="Account Number" i18n-label [value]="bankAccount.accountNumber" />
    </div>
    <div i18n class="date-added">Date Added: {{ bankAccount.createdDate | date : 'MMM d, y' }}</div>
  </div>

  <div *ngIf="summary?.paymentPaylineAccount as paylineAccount" class="inner-card d-flex flex-column gap-3">
    <div class="account-name" i18n>Payline {{ paylineAccount.accountNumber }}</div>
    <div class="bank-info-grid">
      <app-review-entry label="Currency Type" i18n-label [value]="paylineAccount.currency.name" />
      <app-review-entry label="Account Number" i18n-label [value]="paylineAccount.accountNumber" />
      <app-review-entry label="Payline Bank" i18n-label [value]="paylineAccount.bankName" />
    </div>
    <div i18n class="date-added">Date Added: {{ paylineAccount.createdDate | date : 'MMM d, y' }}</div>
  </div>
</div>
